export default (dateFormat) => {
  const format = dateFormat || ''

  return format.replace('MM', 'm').replace('DD', 'd').replace('YYYY', 'Y')
}
